import type { AssignedState } from "./AssignedStateToggle";

export const matchesAssignedState = (
  flag: boolean,
  state: AssignedState,
): boolean => {
  switch (state) {
    case "any":
      return true;
    case "assigned":
      return flag;
    case "unassigned":
      return !flag;
  }
};
